import { Tooltip } from 'antd';
import type { ReactNode } from 'react';
import { NO_PRINT_PATH_HINT } from '../utils/print.ts';

/** A print control without a print path stays visible, disabled, and says why. */
export const PrintHint = ({ canPrint, children }: { canPrint: boolean; children: ReactNode }) =>
  canPrint ? children : <Tooltip title={NO_PRINT_PATH_HINT}>{children}</Tooltip>;
